import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/sections/Hero";
import { Stats } from "../components/sections/Stats";
import { Services } from "../components/sections/Services";
import { Showcase } from "../components/sections/Showcase";
import { Portfolio } from "../components/sections/Portfolio";
import { Process } from "../components/sections/Process";
import { About } from "../components/sections/About";
import { Testimonials } from "../components/sections/Testimonials";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/Footer";
import { FALLBACK_SERVICES } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [services, setServices] = useState(FALLBACK_SERVICES);
  const [servicesLoading, setServicesLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/services`)
      .then((res) => {
        if (mounted && res.data?.services?.length) {
          setServices(res.data.services);
        }
      })
      .catch(() => {})
      .finally(() => mounted && setServicesLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services services={services} loading={servicesLoading} />
        <Showcase />
        <Portfolio />
        <Process />
        <About />
        <Testimonials />
        <Contact services={services} />
      </main>
      <Footer />
    </div>
  );
}
